export const en = {
  'common.language': 'Language',
  'common.environment': 'Environment',
  'is.reachable': 'is reachable',
  'is.not.reachable': 'is not reachable',
  'not.found.message': 'This page does not exist.',
  'common.back': 'Back',
  'an.error.occurred': 'An error occurred',
  'common.back-office': 'Back-office',
  'common.french': 'French',
  'common.english': 'English',
  'common.routing.game-mechanics': 'Game mechanics',
  'common.routing.dialog': 'Dialogs',
  'common.routing.image': 'Image click',
  'common.routing.multiple-choice': 'Multiple choice questions',
  'common.routing.reorder': 'Reorder',
  'common.routing.single-choice': 'Single choice questions',
  'common.routing.users': 'Users',
  'common.routing.groups': 'Groups',
  'common.routing.files': 'Files',
  'common.routing.statistics': 'Statistics',
  'common.routing.sessions': 'Sessions',
  'common.routing.settings': 'Settings',
  'common.routing.modules': 'Modules',
  'common.routing.roadmap': 'What\'s new',
  'common.routing.certificates': 'Certificates',
  'common.routing.reminders': 'Email reminders',
  'common.routing.organizations': 'Organizations',
  'common.routing.billing': 'Billing',
  'common.routing.sso': 'SSO authentication',
  'theme.dark': 'Dark mode',
  'theme.light': 'Light mode',
  'common.logout': 'Logout',
  'common.users': 'Users',
  'common.group': 'Group',
  'common.groups': 'Groups',
  'common.description': 'Description',
  'common.files': 'Files',
  'common.administration': 'Administration',
  'common.menu': 'Menu',
  'file-upload.success': 'File uploaded successfully.',
  'file-upload.failed': 'File upload failed.',
  'no.files': 'No files.',
  'start-by-uploading-a-file-using-the-button-below': 'Start by uploading a file using the button below.',
  'common.email': 'Email address',
  'common.firstname': 'First name',
  'common.lastname': 'Last name',
  'common.role': 'Role',
  'common.lastConnection': 'Last connection',
  'status.active': 'Active',
  'status.pending': 'Pending',
  'common.search': 'Search',
  'common.add': 'Add',
  'common.export': 'Export',
  'export.truncated': 'Export limited to the first {{max}} rows out of {{total}}: narrow the filters to get them all.',
  'common.status': 'Status',
  'common.action': 'Actions',
  'common.update': 'Update',
  'common.delete': 'Delete',
  'common.impersonate': 'View their workspace',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'good.update.user': 'User update was successful.',
  'bad.update.user': 'Failed to update user.',
  'update.user': 'Update user',
  'input.required.message': 'This field is required',
  'input.email.message': 'Enter your email address!',
  'common.cancel': 'Cancel',
  'good.delete.user': 'User was successfully deleted.',
  'bad.delete.user': 'Failed to delete user.',
  'delete.user': 'Delete user',
  'delete.user.first-message': 'Deleting this user will delete all their statistics and access.',
  'delete.second-message': 'Are you sure?',
  'good.add.user': 'User was successfully added.',
  'bad.add.user': 'Failed to add user.',
  'add.user.emailUsed': 'This email address is already used by an account.',
  'create.user': 'Create user',
  'common.create': 'Create',
  'common.home': 'Home',
  'common.mechanics': 'Mechanics',
  'quiz.result.title': 'Quiz result',
  'quiz.result.questions': 'Correct answers',
  'quiz.result.failure': 'You failed the quiz',
  'quiz.result.success': 'You passed the quiz',
  'quiz.restart': 'Restart',
  'time.left': 'Time left',
  'quiz.question': 'Question',
  'quiz.answer.correct': 'Correct answer',
  'quiz.answer.incorrect': 'Incorrect answer',
  'common.validate': 'Validate',
  'common.finish': 'Finish',
  'messages-history': 'Message history',
  'no.history.infos': 'No history',
  'reset.password.success': 'A reset email has been sent',
  'bad.reset.message': 'Failed to send the reset email.',
  'bad.server-login.message': 'Unable to contact the server!',
  'common.loading': 'Loading',
  'reset.password': 'Reset Password',
  'common.submit': 'Submit',
  'login.return-message': 'Return to login page',
  'input.password': 'Enter your password!',
  'password.not-match.message': 'Passwords do not match',
  'new.password.success': 'Your password has been updated',
  'new.password': 'New Password',
  'new.password.description': 'Enter your new password',
  'common.password': 'Password',
  'common.results': 'results',
  'common.confirm-password': 'Confirm Password',
  'logout.pending': 'Signing out',
  'login.microsoft': 'Login with Microsoft',
  'impossible.read.token': 'Unable to read token!',
  'connection.successful': 'Connection successful!',
  'connection.failed': 'Connection failed!',
  'common.login': 'Login',
  'password.forgot': 'Forgot password?',
  'common.register': 'Register',
  'access.denied.message': 'You do not have access rights to this page.',
  'input.password-confirm': 'Confirm your password',
  'good.register.message': 'Registration was successful.',
  'bad.register.message': 'Registration failed.',
  'finish.register': 'Finish registration',
  'password.confirm': 'Confirm your password',
  'good-order.message': 'The correct order is:',
  'reset.password.description': 'Enter your email address to reset your password',
  'common.login.description': 'Enter your email and password below to login to your account',
  'common.or': 'or',
  'login.tagline': 'Learn.\nProgress.\nGet certified.',
  'login.tagline.sub': 'Your courses, progress and certificates, all in one place.',
  'login.magic-link.cta': 'Get a sign-in link',
  'login.magic-link.description': 'Enter your email: we\'ll send you a sign-in link, no password needed.',
  'login.magic-link.submit': 'Send the link',
  'login.magic-link.sent.title': 'Check your inbox',
  'login.magic-link.sent.description': 'If an account matches {{email}}, a sign-in link has just been sent there. It expires in 15 minutes and works only once.',
  'login.magic-link.resend': 'Resend the link',
  'login.password.cta': 'Sign in with a password',
  'magic-link.checking': 'Signing you in',
  'magic-link.checking.description': 'We are checking your sign-in link.',
  'magic-link.failed.title': 'Invalid or expired link',
  'magic-link.failed.description': 'This link has already been used or has expired. Request a new one from the login page.',
  'magic-link.request-new': 'Request a new link',
  'finish.register.message': 'Enter your email, first name, last name, and password to complete your registration.',
  'good.reset.message': 'The reset email has been sent successfully.',
  'new.password.confirm': 'Confirm New Password',
  'create.account': 'Create Account',
  'create.account.description': 'Enter your information to create an account',
  'create.account.success': 'Your account has been created successfully',
  'first.name': 'First Name',
  'last.name': 'Last Name',
  'reset.password.message': 'Enter your email address to reset your password.',
  'new.password.message': 'Enter your email address and new password',
  'common.ok': 'Valid',
  'common.game-mechanics': 'Game mechanics',
  'quiz-mechanisms.available': 'Available quiz mechanics',
  'common.welcome': 'Welcome',
  'no.content': 'No content',
  'common.confirm': 'Confirm',
  'common.reset': 'Reset',
  'common.empty': 'No data',
  'desc.sort': 'Click to sort in descending order',
  'asc.sort': 'Click to sort in ascending order',
  'cancel.sort': 'Click to cancel sorting',
  'your.informations': 'Your information',
  'you.are': 'You are',
  'your.email': 'Your email',
  'token.creation.message': 'Your token was created on:',
  'token.expiration.message': 'Your token will expire on:',
  'common.hello': 'Hello',
  'user.management': 'User management',
  'add.user': 'Add user',
  'bad.connection': 'Unable to connect',
  'bad.connection.message': 'The password and email entered do not match. Please check your information and log in again.',
  'common.close': 'Close',
  'common.quiz-mechanics': 'Quiz mechanics',
  'mechanisms.available': 'Available mechanics',
  'import.user': 'Import user',
  'good.import.user': 'User import was successful.',
  'bad.import.user': 'Failed to import user.',
  'bad.import.user.none': 'No account was created: every row was rejected.',
  'warn.import.user.partial': 'Partial import: {{count}} row(s) rejected.',
  'download.template': 'Download template',
  'click.to.upload': 'Click to upload',
  'common.import': 'Import',
  'import.csv.help': 'CSV file with columns {{headers}} (semicolon separator). Learners receive an invitation email.',
  'import.csv.groupHelp': 'Optional "groupe" column: the group is created if it does not exist yet.',
  'import.csv.parsed': '{{count}} row(s) detected in “{{file}}”.',
  'import.preview.valid': '{{count}} row(s) ready to import.',
  'import.preview.none': 'No importable row in this file.',
  'import.preview.skipped': '{{count}} row(s) will be skipped:',
  'import.preview.checking': 'Checking for addresses already in use…',
  'import.check.failed': 'Could not check addresses already in use: they will be validated on import.',
  'import.submit': 'Import {{count}} row(s)',
  'import.report.created': '{{count}} account(s) created and invited by email.',
  'import.report.partial': '{{count}} account(s) created and invited by email, {{failed}} row(s) rejected.',
  'import.report.none': 'No account created: all {{count}} row(s) in the file were rejected.',
  'import.report.line': 'Row',
  'import.report.reason': 'Reason',
  'import.error.empty': 'The CSV file is empty.',
  'import.error.badHeader': 'Invalid headers. Expected: email ; firstName ; lastName.',
  'import.error.MISSING_FIELDS': 'Missing required field',
  'import.error.INVALID_EMAIL': 'Invalid email',
  'import.error.DUPLICATE_IN_FILE': 'Duplicate in file',
  'import.error.EMAIL_ALREADY_USED': 'Email already used',
  'import.error.CREATION_FAILED': 'Creation failed',
  'common.settings': 'Settings',
  'unknow.error': 'Unknown error!',
  'common.dashboard': 'Dashboard',
  'impersonate.user': 'View {{name}}\'s workspace',
  'bad.impersonate.user': 'Failed to open this user\'s workspace.',
  'impersonate.user.preview': 'You will see the application exactly as {{name}} sees it: their sessions, their modules, their progress. Their own session stays open on their side, and any module you open is not recorded for them.',
  'impersonate.user.not-read-only': 'This is not a read-only mode: apart from SCORM progress, every action taken from their workspace is really carried out and recorded in their name.',
  'impersonate.user.return-hint': 'A banner at the top of the screen will let you return to your account at any time.',
  'impersonate.user.confirm': 'Open their workspace',
  'impersonate.started': 'You are now viewing {{name}}\'s workspace',
  'impersonate.banner.message': 'You are viewing {{name}}\'s workspace',
  'impersonate.banner.warning': 'Their progress is not recorded, but your other actions are.',
  'impersonate.banner.exit': 'Back to my account',
  'impersonate.exit.failed': 'Could not restore your admin session. Please log in again.',
  'account.validate': 'Validate account',
  'account.validate.confirmation': 'Please confirm your account by clicking the button below.',
  'valid.account.success': 'Your account has been successfully validated!',
  'valid.account.failed': 'Account validation failed. Please try again later.',
  'resend.email.success': 'Validation email sent successfully',
  'resend.email.failed': 'Failed to send validation email',
  'resend.email': 'Resend validation email',
  'scorm.player.title': 'SCORM Module',
  'scorm.player.loading': 'Loading module...',
  'scorm.player.error': 'Error loading SCORM module',
  'scorm.progress.saved': 'Progress saved',
  'scorm.progress.save.error': 'Error saving progress',
  'common.statistics': 'Statistics',
  'common.completionStatus': 'Completion Status',
  'common.successStatus': 'Success Status',
  'common.score': 'Score',
  'common.completedAt': 'Completed At',
  'common.totalTime': 'Total Time',
  'status.completed': 'Completed',
  'status.archived': 'Archived',
  'sessions.name': 'Session',
  'user.sessions.title': 'User sessions',
  'user.sessions.subtitle': 'Sessions and progress for {{name}}',
  'user.sessions.empty': 'This user is not enrolled in any session.',
  'user.sessions.progress': 'Progress',
  'user.sessions.view': 'View sessions',
  'user.progress.label': 'Progress',
  'user.progress.all': 'All progress',
  'user.progress.notStarted': 'Never started',
  'user.progress.inProgress': 'In progress',
  'user.progress.completed': 'Completed',
  'status.incomplete': 'Incomplete',
  'status.not_attempted': 'Not Started',
  'status.unknown': 'Unknown',
  'status.passed': 'Passed',
  'status.failed': 'Failed',
  'login.sso': 'SSO Login',
  'login.sso.with': 'Continue with {{provider}}',
  'sso.error': 'SSO login error',

  // Navigation & common
  'common.modules': 'Modules',
  'common.module': 'Module',
  'common.sessions': 'Sessions',
  'common.session': 'Session',
  'common.allSessions': 'All sessions',
  'common.name': 'Name',
  'common.organizations': 'Organizations',
  'billing.title': 'Billing',
  'billing.help': 'A learner is counted once per contract year, on their first login. Admin accounts never count. This counter observes: it never blocks a session.',
  'billing.month': 'Month',
  'billing.monthlyActive': 'Monthly active',
  'billing.yearlyActive': 'Learners trained',
  'billing.registered': 'Registered learners',
  'billing.freeTier': 'Free plan',
  'billing.freeTier.within': 'Included ({{learners}}/{{limit}})',
  'billing.freeTier.over': 'Beyond free plan',
  'billing.devis.over': 'Beyond {{threshold}} learners: let\'s talk',
  'billing.total': 'Total',
  'billing.empty': 'No organization.',
  'billing.neverBlocked': 'Beyond the free plan, billing follows the counter: no session is ever blocked.',
  'billing.amountDue': 'This month',
  'billing.amountDue.free': 'Included in the free plan ({{limit}} learners trained per year).',
  'billing.amountDue.overFree': 'Beyond the free plan, nothing is charged until you pick a plan: at this pace the year would cost {{amount}}.',
  'billing.amountDue.upfront': 'Year paid upfront ({{amount}}): nothing is due this month.',
  'billing.amountDue.monthly': 'The tier price, billed monthly. Cancellable at any time.',
  'billing.plan.title': 'Your tier',
  'billing.plan.field': 'Tier',
  'billing.tier.FREE': 'Free',
  'billing.tier.S': 'S',
  'billing.tier.M': 'M',
  'billing.tier.L': 'L',
  'billing.tier.XL': 'XL',
  'billing.tier.CUSTOM': 'Custom quote',
  'billing.tier.FREE.help': 'Up to 10 learners over 12 rolling months. Permanent free trial.',
  'billing.tier.S.help': 'Up to 100 learners — €39/month.',
  'billing.tier.M.help': 'Up to 300 learners — €99/month.',
  'billing.tier.L.help': 'Up to 750 learners — €189/month.',
  'billing.tier.XL.help': 'Up to 1,500 learners — €299/month.',
  'billing.tier.CUSTOM.help': 'Beyond 1,500 learners: custom quote.',
  'billing.tier.CUSTOM.notice': 'Beyond 1,500 learners, pricing is on a quote basis — get in touch.',
  'billing.tier.monthlyPrice': 'Monthly price',
  'billing.tier.upfrontYear': 'Year upfront (2 months free)',
  'billing.term.field': 'Payment',
  'billing.term.UPFRONT': 'Upfront',
  'billing.term.MONTHLY': 'Monthly',
  'billing.term.UPFRONT.help': 'The year paid upfront: two months free (10 months paid for 12). Non-refundable.',
  'billing.term.MONTHLY.help': 'Cancellable at any time; billing stops at the end of the current month. No commitment.',
  'billing.learnerCount': 'Counted learners',
  'billing.billedTier': 'Tier {{tier}}',
  'billing.placesRemaining': 'Tier {{tier}} — {{places}} places before {{next}}',
  'billing.placesShort': '{{places}} before {{next}}',
  'billing.leavingSoon': 'Leaving within 3 months',
  'billing.leavingSoon.help': 'Learners who will drop off the counter within 3 months unless re-enrolled or returning.',
  'billing.plan.save': 'Save plan',
  'billing.plan.saved': 'Plan saved.',
  'billing.plan.error': 'Plan not saved.',
  'billing.plan.loading': 'Loading your plan…',
  'billing.plan.belowFloor': 'Your {{learners}} counted learners place your organization on tier {{tier}}, which is therefore already the one billed. Subscribing below would change nothing: those tiers stay greyed out until the counter comes back down. For your learners, nothing is blocked — no session, no certificate.',
  'billing.plan.noPaymentYet': 'The change takes effect immediately. Online payment is coming: no charge is triggered here.',
  'billing.yearly.base': 'Yearly base',
  'billing.yearly.commitmentAmount': 'Committed year',
  'billing.yearly.tolerated': 'Covered learners',
  'billing.yearly.overage': 'Estimated adjustment',
  'billing.yearly.overage.monthly': 'Not applicable: your learners are billed as they go.',
  'billing.yearly.estimate': 'At this pace, the contract year will cost {{amount}}.',
  'billing.profile.title': 'Billing details',
  'billing.profile.help': 'Used as-is on your invoices. An empty field never blocks anything.',
  'billing.profile.companyName': 'Company name',
  'billing.profile.vatNumber': 'VAT number',
  'billing.profile.addressLine1': 'Address',
  'billing.profile.addressLine2': 'Address line 2',
  'billing.profile.postalCode': 'Postal code',
  'billing.profile.city': 'City',
  'billing.profile.country': 'Country',
  'billing.profile.billingEmail': 'Billing email',
  'billing.profile.saved': 'Billing details saved.',
  'billing.profile.error': 'Billing details not saved.',
  'billing.history.title': 'History',
  'billing.history.help': 'Last twelve months. Amounts are recomputed with your current plan: real invoices will come with online payment.',
  'billing.history.month': 'Month',
  'billing.history.counted': 'Counter entries',
  'billing.history.amount': 'Amount',
  'billing.plan': 'Plan',
  'billing.estimatedRevenue': 'Estimated revenue',
  // Storage (#180): measured everywhere, capped on the free plan only.
  'storage.title': 'Storage',
  'storage.size': 'Size',
  'storage.used': 'Used',
  'storage.quota': 'Quota',
  'storage.usedOfQuota': '{{used}} / {{quota}}',
  'storage.remaining': '{{remaining}} left.',
  'storage.moduleCount': '{{count}} module(s)',
  'storage.noQuota': 'Your plan does not impose any storage quota.',
  'storage.overQuota': 'You have exceeded the storage included in the free plan. Your modules remain available to your learners; only new imports are refused until you free up space or move to a paid plan.',
  'storage.overQuota.badge': 'Over quota',
  'storage.uploadRefused': 'Import refused, not enough space: you are using {{used}} of the {{quota}} included in the free plan, and this module needs {{incoming}} more. Delete a module you no longer need, or move to a paid plan to lift the quota.',
  'storage.platform.title': 'Storage per organization',
  'storage.platform.help': 'What the platform actually hosts. The quota only applies to organizations on the free plan: elsewhere we measure without refusing anything.',
  'organization.create': 'Create an organization',
  'organization.create.help': 'The administrator receives an invitation email to finalize their account.',
  'organization.slug': 'Identifier (URL)',
  'organization.members': 'Members',
  'organization.suspended': 'Suspended',
  'organization.suspend': 'Suspend',
  'organization.activate': 'Activate',
  'organization.admin.email': 'Administrator email',
  'organization.edit.title': 'Edit organization',
  'organization.edit.required': 'Name and slug are required.',
  'organization.edit.success': 'Organization updated.',
  'organization.edit.failed': 'Update failed (slug already used or invalid?).',
  'organization.edit.slug.help': 'Changing the slug changes the organization\'s login URL.',
  'organization.delete.title': 'Delete organization',
  'organization.delete.confirm': 'Confirm deletion of "{{name}}"? This action is irreversible.',
  'organization.delete.success': 'Organization deleted.',
  'organization.delete.failed': 'Deletion failed.',
  'organization.delete.notEmpty': 'Remove all members first: a non-empty organization cannot be deleted.',
  'organization.delete.default': 'The default organization cannot be deleted.',
  'organization.members.title': 'Members — {{name}}',
  'organization.members.empty': 'No members.',
  'organization.member.invite.title': 'Invite a member',
  'organization.member.invite.required': 'Email, first name and last name are required.',
  'organization.member.invite.submit': 'Invite',
  'organization.member.invite.success': 'Invitation sent.',
  'organization.member.invite.failed': 'Invitation failed.',
  'organization.member.invite.emailUsed': 'This email is already in use.',
  'organization.member.remove': 'Remove',
  'organization.member.remove.success': 'Member removed.',
  'organization.member.remove.failed': 'Removal failed.',
  'good.add.organization': 'The organization was created and its administrator invited.',
  'bad.add.organization': 'Failed to create the organization.',
  'common.title': 'Title',
  'common.version': 'Version',
  'common.save': 'Save',
  'common.remove': 'Remove',
  'common.choose': 'Choose…',
  'common.participants': 'Participants',

  // White-label / branding
  'branding.identity': 'Application identity',
  'branding.appName': 'Application name',
  'branding.logo': 'Logo',
  'branding.noLogo': 'No logo',
  'branding.favicon': 'Favicon',
  'branding.noFavicon': 'No favicon',
  'branding.colorsTypography': 'Colors & typography',
  'branding.primaryColor': 'Primary color',
  'branding.accentColor': 'Accent color',
  'branding.headingFont': 'Heading font',
  'branding.bodyFont': 'Body font',
  'branding.misc': 'Miscellaneous',
  'branding.footerText': 'Footer text',
  'branding.footerPlaceholder': 'Leave empty for a default footer',
  'branding.defaultLocale': 'Default language',
  'branding.imageTooLarge': 'Image too large (max 512 KB).',
  'branding.readError': 'Could not read the file.',
  'branding.saved': 'Configuration saved.',
  'branding.saveError': 'Save failed.',

  // SCORM modules
  'modules.import.title': 'Import a SCORM module',
  'modules.package': 'Package (.zip)',
  'modules.chooseFile': 'Choose a file…',
  'modules.list.title': 'Modules',
  'modules.empty': 'No module yet. Import a SCORM package.',
  'modules.titlePlaceholder': 'Module name',
  'modules.status.ready': 'Ready',
  'modules.status.processing': 'Processing…',
  'modules.status.failed': 'Failed',
  'modules.selectFile': 'Select a SCORM .zip file.',
  'modules.uploadFailed': 'Import failed',
  'modules.imported': 'Module imported.',
  'modules.deleted': 'Module deleted.',
  'modules.deleteFailed': 'Delete failed.',
  'modules.preview': 'Preview',

  // Sessions (back-office)
  'sessions.create.title': 'Create a session',
  'sessions.namePlaceholder': 'Session name',
  'sessions.selectModule': '— Choose a module —',
  'sessions.startDate': 'Start (optional)',
  'sessions.endDate': 'End (optional)',
  'sessions.noUsers': 'No user.',
  'sessions.list.title': 'Sessions',
  'sessions.empty': 'No session.',
  'sessions.nameRequired': 'Enter a name and a module.',

  // Multi-module paths (#139) and scheduled unlocking (#182)
  'sessions.path.title': 'Path modules',
  'sessions.path.count_one': '{{count}} module',
  'sessions.path.count_other': '{{count}} modules',
  'sessions.path.empty': 'No modules yet. Add one to build the path.',
  'sessions.path.add': 'Add',
  'sessions.path.required': 'A path must contain at least one module.',
  'sessions.path.opensOn': 'Opens on',
  'sessions.path.reorder': 'Move {{title}} within the path',
  'sessions.path.remove': 'Remove {{title}} from the path',
  'sessions.path.stage.on_one': '{{count}} module on the same date',
  'sessions.path.stage.on_other': '{{count}} modules on the same date',
  'sessions.path.stage.immediate_one': '{{count}} module open from the start',
  'sessions.path.stage.immediate_other': '{{count}} modules open from the start',
  'sessions.path.stage.setDate': 'Stage opening date',
  'sessions.path.warn.afterEnd': 'This date falls after the path ends: the module would never open.',
  'sessions.path.warn.beforeStart': 'This date precedes the path start: the module will open when the path begins.',
  'sessions.path.warn.inProgress_one': 'This path has {{count}} enrolled learner. Changing its modules changes their progress: a learner who had completed it will go back to "in progress" and lose access to their certificate.',
  'sessions.path.warn.inProgress_other': 'This path has {{count}} enrolled learners. Changing its modules changes their progress: learners who had completed it will go back to "in progress" and lose access to their certificates.',
  'sessions.progression.label': 'Progression',
  'sessions.progression.free': 'Free',
  'sessions.progression.sequential': 'Sequential',
  'sessions.progression.free.hint': 'Learners take modules in any order they like.',
  'sessions.progression.sequential.hint': 'Each module opens once the previous one is completed. An opening date adds to this rule, it does not replace it.',

  // The path as the learner sees it (#139 / #182)
  'home.path.summary': '{{done}} / {{total}} modules completed',
  'home.path.opensOn': 'Available from {{date}}',
  'home.path.awaitingPrevious': 'Waiting for you once you finish the previous one',
  'scorm.player.step': 'Step {{current}} of {{total}}',
  'sessions.created': 'Session created.',
  'sessions.createFailed': 'Creation failed.',
  'sessions.deleted': 'Session deleted.',
  'sessions.deleteFailed': 'Delete failed.',
  'sessions.new': 'New session',
  'sessions.update.title': 'Edit session',
  'sessions.updated': 'Session updated.',
  'sessions.updateFailed': 'Update failed.',
  'sessions.openModule': 'Open module',
  'sessions.participants.selectAll': 'Select all',
  'sessions.participants.clear': 'Clear all',
  'sessions.participants.addGroup': 'Enrol a group:',

  // User groups (#135)
  'groups.list.title': 'Groups',
  'groups.new': 'New group',
  'groups.empty': 'No group.',
  'groups.memberCount': 'Members',
  'groups.members': 'Members',
  'groups.create.title': 'Create a group',
  'groups.update.title': 'Edit group',
  'groups.namePlaceholder': 'Group name (e.g. Lyon City Council)',
  'groups.nameRequired': 'Enter a name.',
  'groups.nameUsed': 'A group already has this name.',
  'groups.created': 'Group created.',
  'groups.createFailed': 'Creation failed.',
  'groups.updated': 'Group updated.',
  'groups.updateFailed': 'Update failed.',
  'groups.deleted': 'Group deleted.',
  'groups.deleteFailed': 'Delete failed.',
  'groups.delete.title': 'Delete group',
  'groups.delete.message': 'Delete "{{name}}"? Its {{count}} members keep their accounts: only the grouping disappears.',
  'groups.none': 'No group',
  'groups.all': 'All groups',
  'groups.select': '— Choose a group —',
  'groups.bulk.selected': '{{count}} selected',
  'groups.bulk.selectPage': 'Select the whole page',
  'groups.bulk.add': 'Assign',
  'groups.bulk.remove': 'Remove',
  'groups.bulk.added': 'Users assigned to the group.',
  'groups.bulk.removed': 'Users removed from the group.',
  'groups.bulk.failed': 'Operation failed.',

  // Sessions (learner)
  'sessions.my.title': 'My sessions',
  'sessions.my.empty': 'Nothing on the horizon just yet.',
  'sessions.my.start': 'Let\'s go',

  // Learner home. We are talking to someone giving up their own time to learn,
  // not to a record: greet them by name and tell them what is waiting.
  'home.title': 'My trainings',
  'home.subtitle': 'Hello {{name}}! Your trainings, your progress and your certificates are all here.',
  'home.inProgress': 'In progress',
  'home.resume': 'Pick up again',
  'home.review': 'Review',
  'home.completedOn': 'Finished on',
  'home.certificate.download': 'Certificate',
  'home.certificate.error': 'Unable to download the certificate.',
  'home.summary_one': '{{count}} training finished out of {{total}}',
  'home.summary_other': '{{count}} trainings finished out of {{total}}',
  'home.empty.hint': 'As soon as a trainer enrolls you in a training, it will show up here.',

  // Certificates (back-office)
  'common.certificates': 'Certificates',
  'certificates.template.title': 'Certificate template',
  'certificates.field.title': 'Title',
  'certificates.field.body': 'Text',
  'certificates.field.signature': 'Signature',
  'certificates.field.signaturePlaceholder': 'Signatory name (optional)',
  'certificates.field.showScore': 'Show score',
  'certificates.field.showDate': 'Show date',
  'certificates.field.showTotalTime': 'Show time spent',
  'certificates.field.orientation': 'Orientation',
  'certificates.orientation.landscape': 'Landscape',
  'certificates.orientation.portrait': 'Portrait',
  'certificates.field.logo': 'Certificate logo',
  'certificates.logo.help': 'PNG or JPEG, 512 KB max. Otherwise the platform logo is used.',
  'certificates.logo.fallback': 'No dedicated logo — the platform logo will be used.',
  'certificates.logo.upload': 'Upload',
  'certificates.logo.remove': 'Remove',
  'certificates.logo.typeError': 'Unsupported format: PNG or JPEG only.',
  'certificates.logo.sizeError': 'File too large (512 KB max).',
  'certificates.logo.readError': 'Could not read the file.',
  'certificates.field.skeleton': 'PDF skeleton (letterhead)',
  'certificates.skeleton.help': 'Single-page PDF, 3 MB max, unprotected. Used as background; the decorative frame is then not drawn.',
  'certificates.skeleton.active': 'Skeleton uploaded',
  'certificates.skeleton.none': 'No skeleton',
  'certificates.skeleton.upload': 'Upload a PDF',
  'certificates.skeleton.replace': 'Replace',
  'certificates.skeleton.remove': 'Remove',
  'certificates.skeleton.typeError': 'The skeleton must be a PDF file.',
  'certificates.skeleton.sizeError': 'PDF too large (3 MB max).',
  'certificates.skeleton.readError': 'Could not read the PDF.',
  'certificates.field.margins': 'Text margins (points)',
  'certificates.margins.help': 'Text block position, mainly useful with a skeleton. 0 to 300.',
  'certificates.margins.marginTop': 'Top',
  'certificates.margins.marginBottom': 'Bottom',
  'certificates.margins.marginLeft': 'Left',
  'certificates.margins.marginRight': 'Right',
  'certificates.placeholders.help': 'Available variables:',
  'certificates.preview': 'Preview',
  'certificates.previewError': 'Unable to generate the preview.',
  'certificates.saved': 'Template saved.',
  'certificates.saveError': 'Saving failed.',
  'common.reminders': 'Email reminders',
  'reminders.cadence.title': 'Reminder cadence',
  'reminders.message.title': 'Message sent',
  'reminders.field.enabled': 'Enable reminders',
  'reminders.enabled.help': 'Enrolled learners who have not completed their training receive an automatic reminder.',
  'reminders.field.firstDelayDays': 'Delay before the first reminder (days)',
  'reminders.field.frequencyDays': 'Interval between two reminders (days)',
  'reminders.frequencyDays.help': 'At least 3 days: below that, a reminder reads as spam.',
  'reminders.field.maxReminders': 'Maximum number of reminders',
  'reminders.maxReminders.help': 'Between 1 and 10 reminders per enrolment. The “no limit” option is gone: chasing learners indefinitely gets your messages flagged as spam, invitations and certificates included.',
  'reminders.field.sendHour': 'Sending hour (0-23)',
  'reminders.field.subject': 'Subject',
  'reminders.field.body': 'Message body',
  'reminders.placeholders.help': 'Available variables:',
  'reminders.sendTest': 'Send me a test',
  'reminders.testSent': 'Test reminder sent to {{email}}.',
  'reminders.testError': 'Test sending failed. Check the SMTP configuration.',
  'reminders.saved': 'Reminders saved.',
  'reminders.saveError': 'Saving failed.',

  // SSO (#40)
  'common.sso': 'SSO authentication',
  'sso.picker.title': 'Provider to configure',
  'sso.picker.help': 'Pick a provider to show its fields. You can configure and enable several: the ones not on screen stay in place.',
  'sso.picker.configured': 'Already configured:',
  'sso.picker.none': 'No provider configured yet.',
  'sso.picker.status.enabled': 'enabled',
  'sso.picker.status.draft': 'draft',
  'sso.intro': 'Enable one or more identity providers for your organization. Until one is enabled, the login screen shows no SSO button.',
  'sso.master.title': 'SSO sign-in',
  'sso.master.help': 'Master switch, above individual providers. Off until you turn it on; turning it off again removes every SSO button from the login screen without erasing the configurations below.',
  'sso.master.off': 'SSO is off: no button appears on the login screen, even for the providers enabled below.',
  'sso.master.turnedOn': 'SSO sign-in enabled.',
  'sso.master.turnedOff': 'SSO sign-in turned off.',
  'sso.field.enabled': 'Enabled',
  'sso.field.label': 'Button label',
  'sso.label.help': 'Text shown on the login screen.',
  'sso.field.issuer': 'Issuer',
  'sso.field.clientId': 'Client ID',
  'sso.field.clientSecret': 'Client secret',
  'sso.clientSecret.help': 'Encrypted before storage. It will never be displayed again.',
  'sso.clientSecret.stored': 'Secret stored. Leave empty to keep it.',
  'sso.field.entryPoint': 'IdP sign-on URL',
  'sso.field.idpIssuer': 'IdP entity ID',
  'sso.field.idpCert': 'Signing certificate (PEM)',
  'sso.field.allowedDomains': 'Allowed email domains',
  'sso.allowedDomains.help': 'Empty = any domain returned by the provider is accepted. An account is created automatically on first login.',
  'sso.allowedDomains.required': 'This provider also authenticates accounts outside your organization — any Gmail address in Google\'s case. Enter at least one domain before enabling it.',
  'sso.idpSetup.title': 'Declare on the provider side:',
  'sso.saved': 'Provider saved.',
  'sso.saveError': 'Saving failed.',
  'sso.deleted': 'Provider deleted.',
  'sso.deleteError': 'Deletion failed.',
  'sso.delete.title': 'Delete {{provider}}',
  'sso.delete.first-message': 'The configuration and client secret will be lost: restoring it means issuing a new one from the provider. If this provider is enabled, learners who sign in through it will no longer be able to log in.',
  'sso.callback.checking': 'Signing you in',
  'sso.callback.checking.description': 'We are validating your identity with your provider.',
  'sso.callback.failed.title': 'Sign-in failed',
  'sso.callback.failed.description': 'The sign-in link expired or was already used. Start again from the login screen.',
  'sso.error.generic': 'SSO sign-in failed. Try again or contact your administrator.',
  'sso.error.domainNotAllowed': 'Your email domain is not allowed for this organization.',
  'sso.error.accountDisabled': 'Your account is disabled. Contact your administrator.',
  'sso.error.emailAlreadyUsed': 'This address already belongs to another organization.',
  'sso.error.providerUnavailable': 'This identity provider is unavailable.',

  // SCORM player
  'scorm.player.backToSessions': 'My sessions',
  'scorm.player.unavailable': 'Module unavailable for this session.',
  'scorm.player.contentError': 'This module\'s content could not be found. Contact an administrator.',

  // Player end screen (the module called Terminate)
  'scorm.finished.completedTitle': 'Congratulations, you have completed this module!',
  'scorm.finished.title': 'End of module',
  'scorm.finished.redirect': 'You will be redirected automatically in a few seconds…',

  // Impersonation in the player
  'scorm.impersonate.noTracking': 'View mode: progress is not recorded',

  // Module preview (Admin/Trainer)
  'scorm.preview.badge': 'Preview',
  'scorm.preview.noTracking': 'No progress is recorded.',
  'scorm.preview.backToModules': 'Back to modules',
  'scorm.preview.unavailable': 'This module is not ready to be played.',

  // Statistics export
  'stats.export.email': 'Email',
  'stats.export.session': 'Session',
  'stats.export.completion': 'Completion',
  'stats.export.success': 'Success',
  'stats.export.score': 'Score',
  'stats.export.totalTime': 'Total time',
  'stats.export.completedAt': 'Completed at',

  // Statistics dashboard
  'stats.dashboard.progressTitle': 'Progress',
  'stats.dashboard.scope': 'tracked paths (learner × session)',
  'stats.dashboard.noEnrollments': 'No learner enrolled in this scope.',
  'stats.dashboard.notYetUnlocked': 'Not open yet',
  'stats.dashboard.notYetUnlocked.hint': '{{modules}} modules are not unlocked yet for their learners: they count toward the total without counting as falling behind.',
  'stats.dashboard.neverOpened': '{{learners}} enrolled learners have never opened their module: they count towards the total, but do not appear in the table below.',
  'stats.dashboard.averageScore': 'Average score',
  'stats.dashboard.scoredOn': 'over {{scored}} scored paths out of {{total}}',
  'stats.dashboard.noScore': 'No score recorded in this scope',
  'stats.dashboard.successRate': 'Success rate',
  'stats.dashboard.successOn': '{{passed}} passed out of {{evaluated}} assessed',
  'stats.dashboard.noSuccess': 'No success verdict in this scope',
  'stats.dashboard.averageTime': 'Average time spent',
  'stats.dashboard.timedOn': 'over {{timed}} timed paths out of {{total}}',
  'stats.dashboard.noTime': 'No duration recorded in this scope',

  // Back-office home (#201). Sentences, not metric labels: every line on this
  // screen should read out loud. The tone is a colleague catching you up in the
  // morning — warm, never bookkeeping: "still a few people to support", not
  // "4 non-conformities".
  'common.routing.home': 'Home',
  'backHome.greeting': 'Hello {{name}}',
  'backHome.subtitle.attention_one': 'One thing is waiting for you today.',
  'backHome.subtitle.attention_other': '{{count}} things are waiting for you today.',
  'backHome.subtitle.clear': 'All caught up — nothing is waiting for you today.',
  'backHome.section.attention': 'Worth a closer look',
  'backHome.section.upcoming': 'Coming up',
  'backHome.section.today': 'Good news today',
  'backHome.overdue.title_one': '{{name}}: {{count}} learner has not finished yet',
  'backHome.overdue.title_other': '{{name}}: {{count}} learners have not finished yet',
  'backHome.overdue.detail': 'The deadline was {{date}}. Now is a good time for a nudge.',
  'backHome.overdue.more_one': 'And {{count}} other path in the same situation.',
  'backHome.overdue.more_other': 'And {{count}} other paths in the same situation.',
  'backHome.overdue.learners_one': 'In total, {{count}} learner is affected.',
  'backHome.overdue.learners_other': 'In total, {{count}} learners are affected, some across several paths.',
  'backHome.endingSoon.title': '{{name}} ends on {{date}}',
  'backHome.endingSoon.detail_one': '{{count}} learner out of {{total}} still needs a hand.',
  'backHome.endingSoon.detail_other': '{{count}} learners out of {{total}} still need a hand.',
  'backHome.startingSoon.title': '{{name}} starts on {{date}}',
  'backHome.startingSoon.detail_one': '{{count}} learner is expected.',
  'backHome.startingSoon.detail_other': '{{count}} learners are expected.',
  'backHome.completedToday.title_one': '{{count}} learner wrapped up "{{module}}"',
  'backHome.completedToday.title_other': '{{count}} learners wrapped up "{{module}}"',
  'backHome.neverStarted.title_one': '{{count}} learner has not taken the first step yet',
  'backHome.neverStarted.title_other': '{{count}} learners have not taken the first step yet',
  'backHome.neverStarted.detail_one': 'Enrolled in a path that has already started, without opening a single module.',
  'backHome.neverStarted.detail_other': 'Enrolled in a path that has already started, without opening a single module.',
  'backHome.empty': 'Nothing to report: no deadline in sight, nobody to chase. Enjoy it.',
  'backHome.empty.cta': 'Take a look at the paths',

  'notice.stats.title': 'Your data and your training record',
  'notice.stats.intro': '{{appName}} records your progress in order to produce the learning record for your course. This notice is provided for transparency: it requires nothing from you.',
  'notice.stats.purpose': 'Purpose: measure learners’ progress, completion and success, and produce the attendance certificates and records your training provider must be able to supply.',
  'notice.stats.data': 'Data involved: your identity (first name, last name, email address) linked to your progress on the modules.',
  'notice.stats.legalBasis': 'Legal basis: performance of your training contract (GDPR article 6.1.b) and the record-keeping obligations placed on your training provider (article 6.1.c).',
  'notice.stats.rights': 'Your rights: access, rectification, restriction and objection are exercised with your training provider. This notice remains available at any time via the “My data” link.',
  'notice.stats.noConsentNeeded': 'This processing is not based on your consent: there is nothing to accept or decline, and your access to your courses does not depend on it.',
  'notice.stats.acknowledge': 'I have read this notice',
  'notice.stats.manage': 'My data',

  // Product roadmap (admin page)
  'roadmap.title': 'What\'s new & roadmap',
  'roadmap.subtitle': 'Product updates: what is available in your version, and what is coming next.',
  'roadmap.status.done': 'Available',
  'roadmap.status.planned': 'Coming soon',
  'roadmap.status.exploring': 'Exploring',
  'roadmap.items.branding.title': 'White-label branding',
  'roadmap.items.branding.description': 'Logo, colors, fonts and texts customizable to match your organization.',
  'roadmap.items.scorm.title': 'SCORM 1.2 & 2004 modules',
  'roadmap.items.scorm.description': 'Import packages from Storyline, Rise, iSpring, Captivate and other authoring tools.',
  'roadmap.items.sessions.title': 'Sessions & enrollments',
  'roadmap.items.sessions.description': 'Learner cohorts per module, with optional start and end dates.',
  'roadmap.items.statistics.title': 'Statistics & CSV export',
  'roadmap.items.statistics.description': 'Progress, completion and success per session, exportable as CSV.',
  'roadmap.items.privacy.title': 'GDPR information',
  'roadmap.items.privacy.description': 'Learner information notice, documented legal basis and acknowledgement log.',
  'roadmap.items.selfHosted.title': 'Self-hosted installation',
  'roadmap.items.selfHosted.description': 'Turnkey deployment on your own infrastructure, with no cloud dependency.',
  'roadmap.items.modulePreview.title': 'Module preview',
  'roadmap.items.modulePreview.description': 'Test a module right after import, without creating a session or enrollment.',
  'roadmap.items.learnerHome.title': 'Learner home page',
  'roadmap.items.learnerHome.description': 'Home page listing each learner\'s courses and progress.',
  'roadmap.items.certificates.title': 'PDF certificates',
  'roadmap.items.certificates.description': 'Customizable template, generated on completion and downloadable by the learner.',
  'roadmap.items.learnerExperience.title': 'Redesigned learner experience',
  'roadmap.items.learnerExperience.description': 'A cleaner, more polished interface for your learners: course list, progress, certificate download and player.',
  'roadmap.items.emailReminders.title': 'Configurable email reminders',
  'roadmap.items.emailReminders.description': 'Reminder frequency and messages customizable from the admin area.',
  'roadmap.items.csvImport.title': 'Bulk learner import',
  'roadmap.items.csvImport.description': 'Create learner accounts by importing a CSV file.',
  'roadmap.items.magicLink.title': 'Magic link sign-in',
  'roadmap.items.magicLink.description': 'Passwordless sign-in via a link sent by email.',
  'roadmap.items.sso.title': 'Enterprise SSO',
  'roadmap.items.sso.description': 'Enable and configure identity providers (Entra ID, Google Workspace, Okta, OpenID Connect, SAML 2.0) from the admin area.',
  'roadmap.items.webhooks.title': 'Webhooks & API',
  'roadmap.items.webhooks.description': 'Notify your systems (HRIS or other) when a module is completed.',
  'roadmap.items.xapi.title': 'xAPI / cmi5 support',
  'roadmap.items.xapi.description': 'Support for next-generation tracking standards, beyond SCORM.',
  'roadmap.items.organizations.title': 'Organizations',
  'roadmap.items.organizations.description': 'Create organizations to group learners, courses and administration.',
  'roadmap.items.orgUrl.title': 'Per-organization URL',
  'roadmap.items.orgUrl.description': 'Dedicated address for each organization.',
  'roadmap.items.billing.title': 'Billing management',
  'roadmap.items.billing.description': 'Plan, monthly amount, history and billing details, restricted to administrators.',
  'roadmap.items.payments.title': 'Online payment',
  'roadmap.items.payments.description': 'Pay for subscriptions and services directly from the platform.',

  // Qualified self-service trial signup (#155)
  'signup.title': 'Create your trial space',
  'signup.choice.subtitle': 'Who are you? We\'ll tailor the next step to your profile.',
  'signup.choice.org.title': 'I\'m a training organization',
  'signup.choice.org.description': 'Create your free trial space and invite your learners.',
  'signup.choice.learner.title': 'I\'m a learner or a trainer',
  'signup.choice.learner.description': 'You\'re joining an existing organization.',
  'signup.learner.description': 'Learner and trainer accounts are created by your training organization. Reach out to its administrator: they\'ll send you an email invitation. There\'s no self-service sign-up for these profiles.',
  'signup.back': 'Back',
  'signup.form.subtitle': 'A few details to open your space. No credit card required.',
  'signup.form.email': 'Work email',
  'signup.form.email.hint': 'Use your organization\'s address — public providers (gmail, outlook…) aren\'t accepted.',
  'signup.form.orgName': 'Organization name',
  'signup.form.jobTitle': 'Job title (optional)',
  'signup.form.phone': 'Phone (optional)',
  'signup.form.submit': 'Create my trial space',
  'signup.sent.title': 'Check your inbox',
  'signup.sent.description': 'If a valid work email was provided, a confirmation email was just sent to {{email}}. Click the link inside to confirm your address — your request will then be reviewed by our team.',
  'signup.error.publicEmail': 'Please use a work email address.',
  'signup.error.generic': 'Something went wrong. Please try again in a moment.',
  'signup.login': 'I already have an account',
  'signup.prompt': 'Are you a training organization?',
  'signup.cta': 'Create your trial space',

  'confirmTrial.title': 'Confirming your email',
  'confirmTrial.loading': 'Recording your confirmation…',
  'confirmTrial.pending': 'Thanks! Your address is confirmed. Your request is now being reviewed by our team — you\'ll get an email as soon as it\'s approved.',
  'confirmTrial.approved': 'Your space has been approved! Check the activation email we just sent to set your password.',
  'confirmTrial.goToLogin': 'Go to login',
  'confirmTrial.rejected': 'Your request was not approved.',
  'confirmTrial.reason': 'Reason:',
  'confirmTrial.expired': 'This confirmation link has expired. Start a new trial request to get a fresh one.',
  'confirmTrial.error': 'This confirmation link is invalid.',
  'confirmTrial.restart': 'Start a new request',

  // Platform review of trial requests (#155, SuperAdmin)
  'trialRequests.title': 'Trial requests',
  'trialRequests.intro': 'Organizations that confirmed their address and are waiting for their space to be created.',
  'trialRequests.empty': 'No pending requests.',
  'trialRequests.col.org': 'Organization',
  'trialRequests.col.requester': 'Requester',
  'trialRequests.col.jobTitle': 'Job title',
  'trialRequests.col.confirmedAt': 'Confirmed on',
  'trialRequests.col.actions': 'Actions',
  'trialRequests.approve': 'Approve',
  'trialRequests.reject': 'Reject',
  'trialRequests.approved': 'Space created for {{org}} — activation sent.',
  'trialRequests.rejected': 'Request from {{org}} rejected.',
  'trialRequests.error': 'Something went wrong.',
  'trialRequests.rejectTitle': 'Reject the request from {{org}}?',
  'trialRequests.reasonLabel': 'Rejection reason (optional)',
  'trialRequests.reasonPlaceholder': 'e.g. organization could not be identified…',
  'trialRequests.reasonHelp': 'The reason is included in the email sent to the requester.',
  'trialRequests.confirmReject': 'Reject and notify',

  // Per-plan capability gating (#155)
  'plan.locked.cta': 'See plans',
  'branding.locked': 'Brand customization (logo, colors, footer) is reserved for paid plans. On the free plan, the space keeps the PureLMS identity.',
  'sso.locked': 'Single sign-on (SSO) is reserved for paid plans.',
  'footer.free-org': 'Free organization, powered by PureLMS',

  // Organization slug rename (#155)
  'organization.rename.title': 'Rename organization?',
  'organization.rename.warning': 'You\'re changing the slug from “{{from}}” to “{{to}}”. This takes effect immediately and breaks everything pointing to the old address.',
  'organization.rename.break.urls': 'Links and bookmarks to the old address stop working.',
  'organization.rename.break.login': 'The login screen and branding resolved by the old slug no longer respond.',
  'organization.rename.break.emails': 'Emails already sent (login, activation, reminders) point to the old address.',
  'organization.rename.confirm': 'Rename anyway',
}
